import { c as _c } from "react/compiler-runtime";
import { usePdpStore } from "@/stores/usePdpStore";
interface Props {
  field: string;
}
export function useFieldErrorId(field) {
  const $ = _c(2);
  let t0;
  if ($[0] !== field) {
    t0 = state => state.validationErrors[field];
    $[0] = field;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const error = usePdpStore(t0);
  return error ? `${field}-error` : undefined;
}
export default function ValidationError(t0) {
  const $ = _c(5);
  const {
    field
  } = t0;
  let t1;
  if ($[0] !== field) {
    t1 = state => state.validationErrors[field];
    $[0] = field;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const error = usePdpStore(t1);
  if (!error) {
    return null;
  }
  const t2 = `${field}-error`;
  let t3;
  if ($[2] !== error || $[3] !== t2) {
    t3 = <p id={t2} role="alert" className="text-sm text-destructive">{error}</p>;
    $[2] = error;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}